<button (click)="goto(NavDirection.PREV)" class="nav-button"><i class="fas fa-chevron-left"></i></button>
<div class="nav-container">
  <ng-content #items></ng-content>
</div>
<button (click)="goto(NavDirection.NEXT)" class="nav-button"><i class="fas fa-chevron-right"></i></button>
